import { RootState } from '@/store'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { formatMinuteSecond } from '@/utils/format-utils'
import { PlayListWrapper } from './style'

export default memo(function PlayList() {
    const { currentSongIndex, playList } = useSelector((state: RootState) => ({
        currentSongIndex: state.player.currentSongIndex,
        playList: state.player.playList,
    }))

    return (
        <PlayListWrapper>
            {playList?.map((item, index) => {
                return (
                    <div key={item.id} className={`play-item ${currentSongIndex === index ? 'active' : ''}`}>
                        <div className="left">{item.name}</div>
                        <div className="right">
                            <span className="singer">{item.ar?.[0]?.name}</span>
                            <span className="duration">{formatMinuteSecond(item.dt)}</span>
                            <span className="sprite_playlist link"></span>
                        </div>
                    </div>
                )
            })}
        </PlayListWrapper>
    )
})
